module.exports = __webpack_public_path__ + "img/an.0bbb7a84.png";